import { all, fork } from "redux-saga/effects";
import Login from "./auth/loginSaga";
import Logout from "./auth/logoutSaga";
import VerifyEmail from "./auth/verifyEmailSaga";
import AddNewAddress from "./auth/addNewAddressSaga";
import GetUsersList from "./auth/getUsersListSaga";
import UpdateUserStatus from "./auth/updateUserStatusSaga.js";
import DeleteUser from "./auth/deleteUserSaga.js";
import ChangeUserPassword from "./auth/changeUserPasswordSaga.js";
import CreateUser from "./auth/createUserSaga";

import CompleteKYC from "./kyc/completeKYCSaga";
import KYCAuth from "./kyc/kycAuthSaga";
import GetKycDetails from "./kyc/getKycDetailsSaga";
import AdminSubmitKyc from "./auth/adminSubmitKycSaga";

import GetBalance from "./dashboard/getBalanceSaga";
import GetUserData from "./dashboard/getUserDataSaga";
import DepositMoneyPlant from "./dashboard/depositMoneyPlantSaga";
import AddUserBalance from "./dashboard/addUserBalanceSaga";
import ScreenWidth from "./dashboard/setScreenWidthSaga.js";
import GetPartnerAccount from "./dashboard/getPartnerAccountSaga";

import Reports from "./monumpay/reportsSaga";
import ReportInfo from "./monumpay/reportInfoSaga";
import Refund from "./monumpay/refundSaga";

import WithdrawalList from "./transaction/withdrawalSaga";
import DepositList from "./transaction/depositSaga";
import TransactionsList from "./transaction/getAllTransactionSaga";
import AllTradesList from "./transaction/allTradesSaga";
import UpdateWithdrawStatus from "./transaction/updateWithdrawStatus";
import CurrencyPairsSaga from "./transaction/currencyPairsSaga";

import AddWhitelabel from "./whitelabels/whitelabelsSaga.js"
import GetWhiteLabel from "./whitelabels/getWhitelabelSaga.js"
import AddBanking from "./whitelabels/addBankingSaga.js"

import DeletedUsers from "./deletedusers/deletedusersSaga.js"
import { getCorporateDataSaga, updateCorporateStatusSaga } from "./corporate/index.js"
import UpdatePromoCode from "./auth/updatePromoCodeSaga.js"
import SearchUsers from "./auth/searchUsersSaga.js"
import UpdateUserRef from "./dashboard/updateUserRefSaga.js"

export default function* rootSaga() {
  yield all([
    fork(Login),
    fork(Logout),
    fork(VerifyEmail),
    fork(AddNewAddress),
    fork(GetUsersList),
    fork(UpdateUserStatus),
    fork(DeleteUser),
    fork(ChangeUserPassword),
    fork(CreateUser),
    fork(CompleteKYC),
    fork(KYCAuth),
    fork(GetBalance),
    fork(GetUserData),
    fork(DepositMoneyPlant),
    fork(AddUserBalance),
    fork(ScreenWidth),
    fork(Reports),
    fork(ReportInfo),
    fork(Refund),
    fork(WithdrawalList),
    fork(DepositList),
    fork(TransactionsList),
    fork(AllTradesList),
    fork(UpdateWithdrawStatus),
    fork(AddWhitelabel),
    fork(GetWhiteLabel),
    fork(DeletedUsers),
    fork(AddBanking),
    fork(GetPartnerAccount),
    fork(CurrencyPairsSaga),
    fork(GetKycDetails),
    fork(AdminSubmitKyc),
    fork(getCorporateDataSaga),
    fork(updateCorporateStatusSaga),
    fork(UpdatePromoCode),
    fork(SearchUsers),
    fork(UpdateUserRef),
  ]);
}